/**
 Author - Suyash Chandra
 Git - https://bitbucket.org/SuyashChandra/
 **/

import ContactUs from "./ContactUs";

export default ContactUs;
